import React, { useState, useEffect, useContext, useRef } from "react";
import { store } from '../../context/store';
import { useHistory } from 'react-router-dom';

import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import DashboardSelector from "../../components/DashboardSelector";

import AmChartSunburst from "../../components/AmChartSunburst";
import AmChartPie from "../../components/AmChartPie";


import {CARD_STYLE} from "../../constants/styles";
import {CHART_CONTAINER_STYLE} from "../../constants/styles";


import { functions } from "../../constants/common-functions";

export default function SpaceAll() {

    const globalState = useContext(store);
    const { dispatch } = globalState;
    const history = useHistory();

    const refFacility = useRef(null);
	
	
	useEffect(() => {
		 functions.redirectDemoUser(history);
	  }, []);

    /* =========================
       STATE
    ========================== */

    const [sunburstData, setSunburstData] = useState([]);

    const [totalAreaBySpaceType, setTotalAreaBySpaceType] = useState([]);
    const [totalAreaByClassificationItem, setTotalAreaByClassificationItem] = useState([]);
    const [totalCapacityBySpaceType, setTotalCapacityBySpaceType] = useState([]);
    const [totalCapacityByClassificationItem, setTotalCapacityByClassificationItem] = useState([]);

    /* =========================
       DEMO DATA
    ========================== */

    useEffect(() => {

        setSunburstData([
            {
                name: "Focus Space",
                children: [
                    { name: "Open Desk", value: 3200 },
                    { name: "Quiet Booth", value: 1400 }
                ]
            },
            {
                name: "Collaboration",
                children: [
                    { name: "Meeting Rooms", value: 2200 },
                    { name: "Project Rooms", value: 1600 }
                ]
            },
            {
                name: "Support",
                children: [
                    { name: "Storage", value: 900 },
                    { name: "Print / Copy", value: 400 }
                ]
            }
        ]);

        setTotalAreaBySpaceType([
            { name: "Desk", value: 55 },
            { name: "Meeting", value: 25 },
            { name: "Support", value: 15 },
            { name: "Other", value: 5 }
        ]);

        setTotalAreaByClassificationItem([
            { name: "Client Facing", value: 35 },
            { name: "Internal", value: 45 },
            { name: "Shared", value: 20 }
        ]);

        setTotalCapacityBySpaceType([
            { name: "Desk", value: 65 },
            { name: "Meeting", value: 20 },
            { name: "Support", value: 10 },
            { name: "Other", value: 5 }
        ]);

        setTotalCapacityByClassificationItem([
            { name: "Client Facing", value: 30 },
            { name: "Internal", value: 50 },
            { name: "Shared", value: 20 }
        ]);

    }, []);

    /* =========================
       STYLES
    ========================== */

    const thisContainer = {
        display: "flex",
        position: "fixed",
        flexDirection: "column",
        width: "100%",
        minHeight: "100vh",
        left: "0px",
        top: "0px"
    };

    const mainContainer = {
        display: "flex",
        position: "fixed",
        top: "60px",
        left: "60px",
        bottom: "0px",
        right: "0px",
        overflow: "hidden"
    };

    const canvas = {
        position: "absolute",
        top: 30,
        left: 330,
        bottom: 30,
        right: "430px",
        //background: "linear-gradient(180deg, #f2f3f5 0%, #e6e8eb 100%)",
        padding: "20px"
    };

    const drawer = {
        position: "fixed",
        top: "90px",
        right: 0,
        bottom: 30,
        width: "300px",
        display: "flex",
        flexDirection: "column",
        padding: "24px 20px",
        background: "linear-gradient(180deg, #0b0b0d 0%, #15161a 100%)",
        boxShadow: "-12px 0 30px rgba(0,0,0,0.45)",
        color: "#fff",
		borderTopLeftRadius:'17px',
		borderBottomLeftRadius:'17px'
    };

    const pieContainer = {
        display: "flex",
        justifyContent: "center",
        marginTop: "-20px"
    };

    const pieTitle = {
        display: "flex",
        justifyContent: "center",
        fontSize: "12px",
        opacity: 0.85,
        marginBottom: "0px",
        letterSpacing: "0.3px"
    };

    const sectionDivider = {
        height: "1px",
        background: "rgba(255,255,255,0.08)",
        margin: "12px 0"
    };
	
	// KPI TILE STYLES (Space Dashboard flavour)

	const kpiTile = {
	    background: "linear-gradient(180deg, #0d1116 0%, #151b22 100%)",
	    borderRadius: "16px",
	    padding: "18px 18px",
	    boxShadow: "0 14px 32px rgba(0,0,0,0.28)",
	    display: "flex",
	    flexDirection: "column",
	    gap: "6px"
	};

	const kpiLabelDark = {
	    fontSize: "11px",
	    letterSpacing: "0.8px",
	    textTransform: "uppercase",
	    color: "rgba(255,255,255,0.55)"
	};

	const kpiValueAccent = (color) => ({
	    fontSize: "30px",
	    fontWeight: 700,
	    color: color,
	    lineHeight: "1.1"
	});

	const kpiSubDark = {
	    fontSize: "13px",
	    color: "rgba(255,255,255,0.6)"
	};

	// Calm, planning-style accents
	const SPACE_ACCENT = "#4dd0e1";
	const PEOPLE_ACCENT = "#7aa2ff";
	const RATIO_ACCENT  = "#b18cff";
	
	const metricsRail = {
	    position: "absolute",
	    top: 30,
	    left: 30,
	    width: "200px",
	    padding: "22px 20px",
	    background: "rgba(255,255,255,0.75)",
	    borderRadius: "14px",
	    boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
	    display: "flex",
	    flexDirection: "column",
	    gap: "22px",          // 👈 controls vertical rhythm
	    backdropFilter: "blur(6px)",
		paddingBottom:'60px'
	};

	const metricBlock = {
	    display: "flex",
	    flexDirection: "column",
		paddingTop:'40px'
	};

	const metricLabel = {
	    fontSize: "11px",
	    letterSpacing: "0.8px",
	    textTransform: "uppercase",
	    color: "#666",
	    marginBottom: "6px"
	};

	const metricValue = {
	    fontSize: "32px",
	    fontWeight: 600,
	    color: "#111"
	};

	const metricSub = {
	    fontSize: "14px",
	    color: "#444",
	    marginTop: "4px"
	};
	
	
	const railDivider = {
	    height: "1px",
	    background: "rgba(0,0,0,0.08)",
	    margin: "6px 0"
	};
	
	
	const railControls = {
	    display: "flex",
	    flexDirection: "column",
	    gap: "10px"
	};

	const railSelect = {
	    height: "32px",
	    borderRadius: "8px",
	    border: "1px solid #ddd",
	    fontSize: "12px",
	    padding: "0 10px",
	    background: "#fff"
	};
	
	
	const railToggle = {
	    display: "flex",
	    background: "#eee",
	    borderRadius: "16px",
	    padding: "2px",
	    marginTop: "6px"
	};

	const railToggleOption = (active) => ({
	    flex: 1,
	    textAlign: "center",
	    padding: "6px 0",
	    fontSize: "12px",
	    borderRadius: "14px",
	    cursor: "pointer",
	    background: active ? "#111" : "transparent",
	    color: active ? "#fff" : "#555",
	    transition: "all 0.2s ease"
	});
	
	const overlayStyle = {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    width: "100%",
	    height: "100%",

	    background: "rgba(255,255,255,0.85)",

	    pointerEvents: "none",

	    opacity: 0,

	    animation: "fadeOverlay 4s ease forwards"
	  };

    /* =========================
       RENDER
    ========================== */

    return (
        <div style={thisContainer}>
            <Header />
            <LeftMenu />
			<div style={overlayStyle}/>
            <DashboardSelector
                title="Space Dashboard"
                childDashboards={[]}
            />

            <div style={mainContainer}>

			
			<div style={metricsRail}>
			{/* KPI TILES */}
			<div style={kpiTile}>
			    <div style={kpiLabelDark}>Total Space</div>
			    <div style={kpiValueAccent(SPACE_ACCENT)}>11,700</div>
			    <div style={kpiSubDark}>m²</div>
			</div>

			<div style={kpiTile}>
			    <div style={kpiLabelDark}>Total Headcount</div>
			    <div style={kpiValueAccent(PEOPLE_ACCENT)}>1,240</div>
			    <div style={kpiSubDark}>people</div>
			</div>

			<div style={kpiTile}>
			    <div style={kpiLabelDark}>Space per Person</div>
			    <div style={kpiValueAccent(RATIO_ACCENT)}>9.4</div>
			    <div style={kpiSubDark}>m² / person</div>
			</div>
				
				
				<div style={railDivider} />

				    {/* CONTROLS */}
				    <div style={railControls}>
				        <select style={railSelect}>
				            <option>Building</option>
				            <option>HQ</option>
				        </select>

				        <select style={railSelect}>
				            <option>Floor</option>
				            <option>All Floors</option>
				        </select>

				        <select style={railSelect}>
				            <option>Zone</option>
				            <option>All Zones</option>
				        </select>

				        <div style={railToggle}>
				            <div style={railToggleOption(true)}>Area</div>
				            <div style={railToggleOption(false)}>Headcount</div>
				        </div>
				    </div>

			</div>
			
                {/* MAIN CANVAS */}
                <div style={{...canvas}}>
                    <AmChartSunburst
                        width="100%"
                        height="100%"
                        chartData={sunburstData}
                        chartId="spaceallsunburst"
                    />
                </div>
				
				
				
				

				{/* BLACK DRAWER */}
				<div style={drawer}>

				    <div style={pieContainer}>
				        <AmChartPie
				            chartId="pie1"
				            chartData={totalAreaBySpaceType}
				            width="200px"
				            height="200px"
				            categoryKey="name"
				            valueKey="value"
				        />
				    </div>
				    <div style={pieTitle}>Area by Space Type</div>

				    <div style={sectionDivider} />

				    <div style={pieContainer}>
				        <AmChartPie
				            chartId="pie2"
				            chartData={totalAreaByClassificationItem}
				            width="200px"
				            height="200px"
				            categoryKey="name"
				            valueKey="value"
				        />
				    </div>
				    <div style={pieTitle}>Area by CR Class</div>

				    <div style={sectionDivider} />

				    <div style={pieContainer}>
				        <AmChartPie
				            chartId="pie3"
				            chartData={totalCapacityBySpaceType}
				            width="200px"
				            height="200px"
				            categoryKey="name"
				            valueKey="value"
				        />
				    </div>
				    <div style={pieTitle}>Seats by Space Type</div>

				    <div style={sectionDivider} />

				   

				</div>

            </div>
        </div>
    );
}